import { useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { configurePricing } from "./pricing";

const API_BASE = import.meta.env.VITE_API_URL ?? "http://localhost:5050";

let _loaded = false; // module-level: fetch once per session

// Loads the hotel's tax / service / deposit rules from the hotels table (Settings)
// and feeds them into the pricing util, so the dashboard breakdown is data-driven
// (no hardcoded 14% / 12% / 5%). Safe to call from multiple pages — fetches once.
export function usePricingConfig() {
  useEffect(() => {
    if (_loaded) return;
    const token = localStorage.getItem("ai2_token") ?? "";
    let hotelId = "";
    try { hotelId = (jwtDecode(token) as any)?.hotelId || ""; } catch { /* */ }
    if (!hotelId) return;
    axios
      .get(`${API_BASE}/api/hotel/settings/${hotelId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
      .then(({ data }) => {
        configurePricing({
          tax: Number(data?.tax_rate),
          service: Number(data?.service_charge),
          depositPercentage: Number(data?.deposit_percentage),
        });
        _loaded = true;
      })
      .catch(() => { /* keep inclusive defaults */ });
  }, []);
}
